import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchUsersByRole } from "../../redux/actions/userActions";
import { setActiveRole, setActiveUser, setActiveUserTab } from "../../redux/actions/dashboardActions";
import GoogleMapView from "../GoogleMapView";
import useIsMobile from "../../hooks/useIsMobile";
import UserPrestataireForAdmin from "../UserPrestataireForAdmin";
import UserDonneurOrdreForAdmin from "../UserDonneurOrdreForAdmin";
import CreatePrestataire from "../CreatePrestataire";

const roles = [
    { key: "client", label: "Clients", stateKey: "clients", totalKey: "totalClients" },
    { key: "prestataire", label: "Prestataires", stateKey: "prestataires", totalKey: "totalPrestataire" },
    { key: "donneur_ordre", label: "Donneurs d’Ordres", stateKey: "donneursOrdres", totalKey: "totalDonneursOrdres" },
    { key: "admin", label: "Admins", stateKey: "admins", totalKey: "totalAdmins" },
];

const tabList = [
    { id: "infos", label: "Informations personnelles" },
    { id: "entreprise", label: "Mon entreprise" },
    { id: "presentation", label: "Présentation" },
    { id: "localisation", label: "Localisation" },
    { id: "competences", label: "Mes compétences" },
    { id: "realisations", label: "Mes réalisations" },

];
const USER_TABS_BY_ROLE = {
    client: [
        { key: "infos", label: "Informations personnelles" },

        { key: "projects", label: "Projets" },
        { key: "messages", label: "Messages" },
    ],
    prestataire: [
        { key: "infos", label: "Informations personnelles" },
        { key: "entreprise", label: "Entreprise" },
        { key: "presentation", label: "Présentation" },
        { key: "localisation", label: "Localisation" },
        { key: "competences", label: "Compétences" },
        { key: "realisations", label: "Réalisations" },

    ],
    donneur_ordre: [
        { key: "profil", label: "Profil" },
        { key: "projects", label: "Projets" },
        { key: "billing", label: "Facturation" },
    ],
    admin: [
        { key: "profil", label: "Profil" },
        { key: "permissions", label: "Permissions" },
    ],
};
const getNameStatut = (idStatut) => {
    switch (idStatut) {
        case "micro-entrepreneur":
            return "Micro-entrepreneur (ME)";
        case "eirl":
            return "Entreprise Individuelle (EI)";
        default:
            return idStatut.toUpperCase();
    }
};


const getUserField = (user, roleKey, fieldType) => {

    if (!user) return "";

    const mappings = {
        client: {
            firstName: () => user?.profilClient?.firstNameClient ?? "",
            lastName: () => user?.profilClient?.lastNameClient ?? "",
            city: () => user?.profilClient?.cityClient ?? "",
            email: () => user?.mailUser ?? "",
            isOnline: () => Boolean(user?.isOnline),
        },
        prestataire: {
            firstName: () => user?.profilPrestataire?.firstNamePrestataire ?? "",
            lastName: () => user?.profilPrestataire?.lastNamePrestataire ?? "",
            city: () => user?.profilPrestataire?.villePrestataire ?? "",
            email: () => user?.mailUser ?? "",
            isOnline: () => Boolean(user?.isOnline),
        },
        donneur_ordre: {
            firstName: () => user?.profilDonneurOrdre?.prenomDonneurOrdre ?? "",
            lastName: () => user?.profilDonneurOrdre?.nomDonneurOrdre ?? "",
            city: () => user?.profilDonneurOrdre?.adresseFacturation?.ville ?? "",
            email: () => user?.mailUser ?? "",
            isOnline: () => Boolean(user?.isOnline),
        },
        admin: {
            firstName: () => "",
            lastName: () => "",
            city: () => "",
            email: () => user?.mailUser ?? "",
            isOnline: () => Boolean(user?.isOnline),
        },
        default: {
            firstName: () => user?.prenom ?? "",
            lastName: () => user?.nom ?? "",
            city: () => user?.ville ?? "",
            email: () => user?.email ?? "",
            isOnline: () => Boolean(user?.isOnline),
        },
    };

    const roleMap = mappings[roleKey] ?? mappings.default;
    return roleMap[fieldType] ? roleMap[fieldType]() : "";
};

const UsersTable = ({ users = [], roleKey, resultsPerPage, page, setPage, total, usersOnline, onUserClick }) => {
    const totalPages = Math.max(1, Math.ceil(total / resultsPerPage));

    return (

        <div className="users-table-container">
            <div className="table-wrapper">
                <table className="users-table">
                    <thead>
                        <tr>
                            {roleKey !== "admin" && <>
                                <th>Nom</th>
                                <th>Prénom</th>
                                <th>Ville</th>
                            </>}
                            <th>Email</th>
                            <th>Statut</th>
                        </tr>
                    </thead>
                    <tbody>
                        {users.length > 0 ? users.map((user) => {
                            const key = user?.idUser ?? JSON.stringify(user);
                            const lastName = getUserField(user, roleKey, "lastName");
                            const firstName = getUserField(user, roleKey, "firstName");
                            const city = getUserField(user, roleKey, "city");
                            const email = getUserField(user, roleKey, "email");
                            const isOnline = usersOnline[user?.idUser] === true;

                            return (
                                <tr key={key} onClick={() => onUserClick && onUserClick(user)}>
                                    {roleKey !== "admin" && <>
                                        <td>{lastName}</td>
                                        <td>{firstName}</td>
                                        <td>{city}</td>
                                    </>}
                                    <td>{email}</td>
                                    <td style={{ color: isOnline ? "green" : "red" }}>
                                        {isOnline ? "En ligne" : "Hors ligne"}
                                    </td>
                                </tr>
                            );
                        }) : (
                            <tr>
                                <td colSpan={roleKey !== "admin" ? 5 : 2} style={{ textAlign: "center", padding: "12px" }}>
                                    Aucun utilisateur
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            {/* Pagination */}
            <div className="pagination">
                <button onClick={() => setPage(Math.max(page - 1, 1))} disabled={page === 1}>Précédent</button>
                <span>Page {page} / {totalPages}</span>
                <button onClick={() => setPage(Math.min(page + 1, totalPages))} disabled={page >= totalPages}>Suivant</button>
            </div>

            {/* Mobile cards */}
            <div className="cards-wrapper">
                {users.map((user) => {
                    const key = user?.idUser ?? JSON.stringify(user);
                    const lastName = getUserField(user, roleKey, "lastName");
                    const firstName = getUserField(user, roleKey, "firstName");
                    const city = getUserField(user, roleKey, "city");
                    const email = getUserField(user, roleKey, "email");
                    const isOnline = usersOnline[user?.idUser] === true;

                    return (
                        <div key={key} className="user-card" onClick={() => onUserClick && onUserClick(user)}>
                            {roleKey !== "admin" && <p><strong>Nom:</strong> {lastName}</p>}
                            {roleKey !== "admin" && <p><strong>Prénom:</strong> {firstName}</p>}
                            {roleKey !== "admin" && <p><strong>Ville:</strong> {city}</p>}
                            <p><strong>Email:</strong> {email}</p>
                            <p><strong>Statut:</strong> <span style={{ color: isOnline ? "green" : "red" }}>{isOnline ? "En ligne" : "Hors ligne"}</span></p>
                        </div>
                    );
                })}
            </div>

            <style jsx>{`
  .table-wrapper { overflow-x: auto; }
  .users-table { width: 100%; border-collapse: collapse; min-width: 600px; }
  .users-table th, .users-table td { border: 1px solid #ddd; padding: 8px; text-align: left; }

  /* Ligne hover */
  .users-table tbody tr:hover {
    background-color: #f0f8ff; /* bleu clair par exemple */
    cursor: pointer; /* montre que c'est cliquable */
  }

  .cards-wrapper { display: none; }
  .user-card { border: 1px solid #ddd; padding: 12px; margin-bottom: 12px; border-radius: 6px; background-color: #f9f9f9; }
  .pagination { margin-top: 0.5rem; display: flex; align-items: center; gap: 8px; }

  @media (max-width: 768px) {
    .users-table { display: none; }
    .cards-wrapper { display: block; }
    .user-card p { margin: 4px 0; font-size: 14px; }
  }
`}</style>

        </div>

    );
};

const UsersInscritsDashboard = () => {
    const dispatch = useDispatch();
    const token = useSelector((state) => state.auth?.token);
    const userState = useSelector((state) => state.user);
    const usersOnline = useSelector((state) => state.online.usersOnline);
    const { activeRole, activeUser, activeUserTab } = useSelector((state) => state.dashboard);
    const isMobile = useIsMobile(768);
    const [pages, setPages] = useState({ client: 1, prestataire: 1, donneur_ordre: 1, admin: 1 });
    const [resultsPerPage, setResultsPerPage] = useState(window.innerWidth <= 768 ? 5 : 10);
    const apiUrl = process.env.REACT_APP_API_URL;
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const [showFormPresta, setShowFormPresta] = useState(false);
    const userTabs = activeRole
        ? USER_TABS_BY_ROLE[activeRole] ?? []
        : [];

    // Handle resize for mobile/desktop
    useEffect(() => {
        const handleResize = () => setResultsPerPage(window.innerWidth <= 768 ? 5 : 10);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
        ["client", "prestataire", "donneur_ordre", "admin"].forEach(role => {
            dispatch(fetchUsersByRole(token, role, 1, resultsPerPage));
        });
    }, [dispatch, token, resultsPerPage]);
    // Fetch users for active role and page
    useEffect(() => {
        dispatch(fetchUsersByRole(token, activeRole, pages[activeRole], resultsPerPage));
    }, [dispatch, token, activeRole, pages, resultsPerPage]);

    useEffect(() => {
        if (!activeUser || userTabs.length === 0) return;

        const isValidTab = userTabs.some(tab => tab.key === activeUserTab);

        if (!isValidTab) {
            dispatch(setActiveUserTab(userTabs[0].key));
        }
    }, [activeUser, activeRole]);

    const handlePageChange = (roleKey, newPage) => {
        setPages(prev => ({ ...prev, [roleKey]: newPage }));
    };


    const handleDeleteUser = async () => {
        if (!activeUser) return;

        const confirmDelete = window.confirm(
            "Voulez-vous vraiment supprimer cet utilisateur ? Cette action est irréversible."
        );

        if (!confirmDelete) return;

        try {
            const formData = new FormData();
            formData.append("idUser", activeUser.idUser);
            const response = await fetch(`${apiUrl}/api/delete/account`, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                body: formData,
            });

            const data = await response.json();

            if (!response.ok) {
                alert(data.error || "Erreur lors de la suppression");
                return;
            }

            alert("Utilisateur supprimé avec succès");

            // Retour à la liste
            dispatch(setActiveUser(null));

            // Rafraîchir la liste
            dispatch(fetchUsersByRole(token, activeRole, pages[activeRole], resultsPerPage));

        } catch (error) {
            console.error(error);
            alert("Erreur serveur");
        }
    };


    return (
        <>
            {
                !activeUser && (
                    <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
                        <h2>Utilisateurs inscrits</h2>
                        <div><button className="btn-primary" onClick={()=>setShowFormPresta(true)}>AJOUTER UN PRESTATAIRE</button></div>
                        {
                            showFormPresta&&(
                                <CreatePrestataire onClose={()=>setShowFormPresta(false)} onSuccess = {()=>dispatch(fetchUsersByRole(token, activeRole, pages[activeRole], resultsPerPage))}/>
                            )
                        }
                        {/* Onglets */}
                        <div className="tabs">
                            {roles.map(({ key, label, stateKey, totalKey }) => {

                                const users = userState?.[stateKey] ?? [];
                                const total = userState?.[totalKey] ?? users.length;

                                return (

                                    <button
                                        key={key}
                                        onClick={() => dispatch(setActiveRole(key))}
                                        className={activeRole === key ? "active" : ""}
                                    >
                                        {total} {label}
                                    </button>
                                )
                            })}
                        </div>

                        {/* Tableau / cartes */}
                        {roles.map(({ key, stateKey, totalKey }) => {
                            if (key !== activeRole) return null;
                            const users = userState?.[stateKey] ?? [];
                            const total = userState?.[totalKey] ?? users.length;

                            return (
                                <UsersTable
                                    key={key}
                                    users={users}
                                    roleKey={key}
                                    resultsPerPage={resultsPerPage}
                                    page={pages[key]}
                                    setPage={(newPage) => handlePageChange(key, newPage)}
                                    total={total}
                                    usersOnline={usersOnline}
                                    onUserClick={(user) => dispatch(setActiveUser(user))} // <-- ici

                                />
                            );
                        })}

                        <style jsx>{`
        .tabs { display: flex; gap: 8px; margin-bottom: 1rem;justify-content: center; }
        .tabs button { padding: 8px 12px; border: 1px solid #ccc; border-radius: 4px; background: #f0f0f0; cursor: pointer; }
        .tabs button.active { background: #0070f3; color: white; border-color: #0070f3; }
      `}</style>
                    </div>
                )
            }
            {
                activeUser && (
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                        <h2>{activeUser.mailUser}</h2>
                        <button
                            className="btn-danger"
                            onClick={handleDeleteUser}
                        >
                            SUPPRIMER L’UTILISATEUR
                        </button>
                        <style jsx>{`
                .btn-danger {
                    background: #dc3545;
                    color: white;
                    border: none;
                    padding: 8px 14px;
                    border-radius: 4px;
                    cursor: pointer;
                }
                .btn-danger:hover {
                    background: #c82333;
                }
            `}</style>
                        <button className="btn-primary" onClick={() => dispatch(setActiveUser(null))}>REVENIR A LA LISTE</button>
                        {activeRole === "prestataire" && (
                            <UserPrestataireForAdmin prestataire={activeUser.profilPrestataire} userActif={activeUser} />
                        )}
                        {
                            activeRole === "donneur_ordre" && (
                                <UserDonneurOrdreForAdmin donneurOrdre={activeUser.profilDonneurOrdre} />
                            )
                        }
                    </div>



                )
            }

        </>

    );
};

export default UsersInscritsDashboard; 